"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const OsmosysBaseEntity_1 = require("../OsmosysBaseEntity");
const emails_1 = require("../emails");
const Integration_1 = require("../integrations/Integration");
const auth_1 = require("../auth");
const WorkflowRun_1 = require("./WorkflowRun");
const Workspace_1 = require("../auth/Workspace");
let Workflow = class Workflow extends OsmosysBaseEntity_1.OsmosysBaseEntity {
};
tslib_1.__decorate([
    type_graphql_1.Field(() => auth_1.User),
    typeorm_1.ManyToOne(() => auth_1.User, {
        cascade: true,
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], Workflow.prototype, "creatingUser", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => WorkflowRun_1.WorkflowRun, { nullable: true }),
    typeorm_1.OneToOne(() => WorkflowRun_1.WorkflowRun, workflowRun => workflowRun.workflowMeta, {
        nullable: true,
        onDelete: 'CASCADE',
    }),
    tslib_1.__metadata("design:type", Object)
], Workflow.prototype, "metaForWorkflowRun", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column(),
    tslib_1.__metadata("design:type", String)
], Workflow.prototype, "name", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => emails_1.Email, { nullable: true }),
    typeorm_1.ManyToOne(() => emails_1.Email, {
        lazy: true,
        nullable: true,
    }),
    tslib_1.__metadata("design:type", Object)
], Workflow.prototype, "email", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Workspace_1.Workspace),
    typeorm_1.ManyToOne(() => Workspace_1.Workspace),
    typeorm_1.JoinColumn(),
    tslib_1.__metadata("design:type", Object)
], Workflow.prototype, "workspace", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [WorkflowRun_1.WorkflowRun]),
    typeorm_1.OneToMany(() => WorkflowRun_1.WorkflowRun, workflowRun => workflowRun.workflow),
    tslib_1.__metadata("design:type", Object)
], Workflow.prototype, "runs", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [auth_1.User]),
    typeorm_1.ManyToMany(() => auth_1.User, user => user.workflowsToApprove),
    typeorm_1.JoinTable(),
    tslib_1.__metadata("design:type", Object)
], Workflow.prototype, "usersThatCanApprove", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [auth_1.User]),
    typeorm_1.ManyToMany(() => auth_1.User, user => user.workflowProofsSent),
    typeorm_1.JoinTable(),
    tslib_1.__metadata("design:type", Object)
], Workflow.prototype, "usersToSendProofsTo", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [String], { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'simple-array',
    }),
    class_validator_1.ArrayUnique(),
    tslib_1.__metadata("design:type", Array)
], Workflow.prototype, "days", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    typeorm_1.Column({ default: false, type: 'boolean' }),
    tslib_1.__metadata("design:type", Boolean)
], Workflow.prototype, "everyday", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    typeorm_1.Column({ default: false, type: 'boolean' }),
    tslib_1.__metadata("design:type", Boolean)
], Workflow.prototype, "sendProof", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Number, { nullable: true }),
    typeorm_1.Column({ nullable: true, type: 'int' }),
    tslib_1.__metadata("design:type", Number)
], Workflow.prototype, "minutesBeforeRunToSendProof", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({ nullable: true, type: 'timestamp' }),
    tslib_1.__metadata("design:type", Object)
], Workflow.prototype, "time", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    typeorm_1.Column({ default: false, type: 'boolean' }),
    tslib_1.__metadata("design:type", Boolean)
], Workflow.prototype, "requireApproval", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Integration_1.Integration, { nullable: true }),
    typeorm_1.ManyToOne(() => Integration_1.Integration, { nullable: true }),
    tslib_1.__metadata("design:type", Object)
], Workflow.prototype, "emailServiceProvider", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], Workflow.prototype, "campaignFromEmailAddress", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], Workflow.prototype, "campaignFromName", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], Workflow.prototype, "campaignDefaultSubjectLine", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({ nullable: true, type: 'character varying' }),
    tslib_1.__metadata("design:type", Object)
], Workflow.prototype, "campaignReplyToEmailAddress", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({ nullable: true, type: 'character varying' }),
    tslib_1.__metadata("design:type", Object)
], Workflow.prototype, "campaignListID", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    class_validator_1.IsIn(['defaultText', 'contentSystem', 'manualSubjectLine']),
    tslib_1.__metadata("design:type", Object)
], Workflow.prototype, "campaignSubjectLineSource", void 0);
Workflow = tslib_1.__decorate([
    type_graphql_1.ObjectType(),
    typeorm_1.Entity()
], Workflow);
exports.Workflow = Workflow;
class WorkflowEntity extends Workflow {
    toString() {
        return this.name || `Workflow #${this.id}`;
    }
}
exports.WorkflowEntity = WorkflowEntity;
//# sourceMappingURL=Workflow.js.map